<div class="cosmos-confirm-dialog__container">
  <h1 mat-dialog-title>{{ data.dialogTitle || "Are you sure?" }}</h1>
  <mat-dialog-content>
    <p>
      {{ data.dialogMessage }}
    </p>
  </mat-dialog-content>
    <div class="cosmos-confirm-dialog__buttons">
      <button
        (click)="onConfirmClick(false)"
        class="cosmos-confirm-dialog__buttons__cancel-button"
      >
        {{ data.cancelText }}
      </button>
      <button
        (click)="onConfirmClick(true)"
        class="cosmos-confirm-dialog__buttons__confirm-button"
      >
        {{ data.confirmText }}
      </button>
    </div>
</div>
